module.exports = __webpack_public_path__ + "media/images/webpage/hotels/staff_members/japanese_chef_male-8d18b997c64a9b527954109eceb0e268.webp";